import { I18nextProvider } from 'react-i18next';
import config from './config';

const I18nProvider = ({ children }) => (
  <I18nextProvider i18n={config}>{children}</I18nextProvider>
);

export default I18nProvider;
